import { LoyaltyApiSdk } from '~api/LoyaltyApiSdk';
import { IAppConfigWithRequestedBUIDKeys } from '~domain/entities/IConfig';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { diContainer, serviceNames } from '~setup/diContainer';

export class LoyaltyServiceStartedUseCase {
    private apiSdk: LoyaltyApiSdk;
    private configRepository: ConfigRepository;
    private configs: IAppConfigWithRequestedBUIDKeys;

    constructor(configs: IAppConfigWithRequestedBUIDKeys) {
        this.apiSdk = diContainer.get(serviceNames.loyaltyApiSdk);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.fetchConfigs(this.configs);
        this.apiSdk.setConfigs(this.configRepository.config);
    };
}
